import { TransformConvertorBase } from './transform.convertor';
import { ColumnMappingConvertor } from './mapping.convertor';
import { BaseColumnMappingTransformation } from 'app/model/dataflow/base-column-mapping-transformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { ColumnMappingBaseTransformPlainObject } from 'worker/app-workers/shared/plainObjects/columnMappingBase.plainObject';
import { OutputTransformation } from 'app/model/dataflow/outputtransformation';
import { OutputPlainObject } from 'worker/app-workers/shared/plainObjects/output.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class OutputConvertor extends TransformConvertorBase {
    constructor(outputObject: OutputPlainObject, output: OutputTransformation) {
        super(outputObject, output);
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        ColumnMappingConvertor.convertFromPlainObject(
            this.transformObject as ColumnMappingBaseTransformPlainObject,
            this.transformation as BaseColumnMappingTransformation,
            this._handledConfigs
        );
        super.postConvert();
        return this.transformation;
    }
}
